<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :formsConfig="formsConfig"
    :hot-key-create-path="'/price-group/create'"
    :hot-key-grid-tab-index="selectedIndex"
    :hot-key-expand="currentExpandFunction"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Price Group"
        :baseView="baseView"
        :primaryLabel="model.Name"
        :secondaryLabel="model.Description"
      />
    </template>

    <gc-tabs
      :tabs="tabs"
      :selected-index.sync="selectedIndex"
      v-if="this.applicationMode == 'GcorpRoam' ? true : false"
    />

    <div class="price-group css-v2 transaction-screen">
      <div
        v-bind:class="
          (selectedIndex == 0 && !customerGridExpanded) ||
          (selectedIndex == 1 && !productGridExpanded)
            ? 'gc-header-form'
            : 'gc-header-form expanded'
        "
      >
        <div class="gc-form-header-toolbar">
          <DxToolbar
            ref="toolbar-header"
            class="
              view-toolbar
              price-group-toolbar
              form-header-toolbar
              dx-toolbar
            "
          >
            <DxItem
              widget="dxForm"
              location="after"
              :options="{
                formData: model,
                items: toolbarActiveItems,
                validationGroup: 'toolbarForm',
                labelLocation: 'left',
                disabled: baseView.mode == 'review' ? true : false,
              }"
              locate-in-menu="auto"
              :disabled="baseView.mode == 'review' ? true : false"
              ref="so-toolbar-form"
            ></DxItem>

            <!-- <DxItem
          :options="toolbar.filter"
          location="after"
          locate-in-menu="auto"
          widget="dxButton"
          :visible="dataGrid.model.Review == 'P'"
        /> -->
            <DxItem
              :options="toolbar.audit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
            />
            <DxItem
              :options="toolbar.edit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
              :visible.sync="isEditVisible"
            />
            <DxItem
              :options="toolbar.save"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode != 'review'"
              ref="headerSaveMenu"
            />
          </DxToolbar>
        </div>

        <div
          v-show="
            (selectedIndex == 0 && !customerGridExpanded) ||
            (selectedIndex == 1 && !productGridExpanded)
          "
          class="view-card responsive-paddings price-group-form"
        >
          <form v-if="formDataLoaded">
            <DxForm
              :form-data.sync="model"
              :read-only="false"
              :show-colon-after-label="false"
              :show-required-mark="false"
              :show-validation-summary="false"
              :validation-group="formsConfig.validationGroup"
              label-location="left"
              :customizeItem="customizeItem"
              :items="formItems"
              :ref="'price-group-form-details'"
              @content-ready="onContentReady"
            >
              <template #soTemplate="{ data }">
                <div class="custom-auto-complete">
                  <span class="auto-complete-primary">{{
                    data.Description
                  }}</span>
                  <span class="auto-complete-secondary">{{ data.Code }}</span>
                </div>
              </template>
            </DxForm>
          </form>
        </div>
      </div>

      <div v-if="selectedIndex == 0" class="view-card">
        <!-- <GcDataGrid :key="selectedIndex" :options.sync="gridOptions"> </GcDataGrid> -->

        <div v-if="SessionCreated">
          <dx-data-grid
            :key="selectedIndex"
            :show-borders="true"
            :ref="'customer-grid'"
            :columns="customerGridColumns"
            :data-source="dataGrid.customer.dataSource"
            :two-way-binding-enabled="false"
            :height="
              (!customerGridExpanded
                ? gridHeight - (formHeight + toolbarHeight)
                : gridHeight - toolbarHeight) - 45
            "
            @content-ready="onContentReadyCustomerGrid"
            @toolbar-preparing="onToolbarPreparingPGCustomer($event)"
            :cache-enabled="true"
            :repaint-changes-only="true"
            @initialized="onInitialized"
            :column-chooser="{ enabled: false }"
          >
            <DxSearchPanel
              :visible="true"
              :highlight-case-sensitive="true"
              :text.sync="searchText"
            />

            <template #include-header-template>
              <DxCheckBox
                ref="cus-select-all"
                v-model="dataGrid.model.selectAll"
                @value-changed="selectAllItems"
                id="select-all"
                class="select-all-class"
                :readOnly="
                  dataGrid.model.Review == 'R' || baseView.mode == 'review'
                    ? true
                    : false
                "
              />
            </template>

            <template #include-cell-template="{ data }">
              <div>
                <DxCheckBox
                  :value="data.data.Include"
                  @value-changed="
                    selectAllItem(
                      $event,
                      data,
                      'cb-' + data.data.RecordId._value
                    )
                  "
                  :readOnly="
                    dataGrid.model.Review == 'R' || baseView.mode == 'review'
                      ? true
                      : false
                  "
                  :ref="'cb-' + data.data.RecordId._value"
                />
              </div>
            </template>
          </dx-data-grid>
        </div>
      </div>

      <div v-if="selectedIndex == 1" class="view-card">
        <!-- <GcDataGrid :key="selectedIndex" :options.sync="gridOptions"> </GcDataGrid> -->

        <gc-filter-split-view
          :showLeftContainer="showLeftContainer"
          :showRightContainer="showRightContainer"
        >
          <template #leftContent>
            <div v-if="SessionCreated">
              <dx-data-grid
                :key="selectedIndex"
                :show-borders="true"
                :ref="'product-grid'"
                :columns="productGridColumns"
                :data-source="dataGrid.product.dataSource"
                :two-way-binding-enabled="false"
                :height="
                  (!productGridExpanded
                    ? gridHeight - (formHeight + toolbarHeight)
                    : gridHeight - toolbarHeight) - 45
                "
                @toolbar-preparing="onToolbarPreparingPGProduct($event)"
                @content-ready="onContentReadyProductGrid"
                :cache-enabled="false"
                @initialized="onInitialized"
                :column-chooser="{ enabled: false }"
              >
                <DxSearchPanel
                  :visible="true"
                  :highlight-case-sensitive="true"
                  :text.sync="searchText"
                />

                <template #include-header-template>
                  <DxCheckBox
                    ref="cus-select-all"
                    v-model="dataGrid.model.selectAll"
                    @value-changed="selectAllItems"
                    id="select-all"
                    class="select-all-class"
                    :readOnly="
                      dataGrid.model.Review == 'R' || baseView.mode == 'review'
                        ? true
                        : false
                    "
                  />
                </template>

                <template #include-cell-template="{ data }">
                  <DxCheckBox
                    :value="data.data.Include"
                    @value-changed="
                      selectAllItem(
                        $event,
                        data,
                        'cb-' + data.data.RecordId._value
                      )
                    "
                    :readOnly="
                      dataGrid.model.Review == 'R' || baseView.mode == 'review'
                        ? true
                        : false
                    "
                    :ref="'cb-' + data.data.RecordId._value"
                  />
                </template>

                <template #method-cell-template="{ data }">
                  <DxSelectBox
                    :items="[
                      { menuText: 'Disc %', data: data },
                      {
                        menuText: 'Special Price',
                        data: data,
                        visible:
                          dataGrid.model.Review == 'P' || data.data.Type == 'P'
                            ? true
                            : false,
                      },
                    ]"
                    keyExpr="menuText"
                    displayExpr="menuText"
                    :drop-down-options="{ width: 170 }"
                    class="gc-dropdown-icon-button gc-border-bottom-dotted"
                    styling-mode="text"
                    :show-arrow-icon="false"
                    @value-changed="onMethodValueChange($event, data)"
                    :value="data.value"
                    valueExpr="menuText"
                    :disabled="
                      dataGrid.model.Review == 'R' || baseView.mode == 'review'
                        ? true
                        : false
                    "
                  />
                </template>

                <template #value-cell-template="{ data }">
                  <div>
                    <DxNumberBox
                      :value="data.value"
                      :format="
                        data.data.PricingMethod == 'Special Price'
                          ? getDecimalFormatByCode(12).Format
                          : getDecimalFormatByCode(6).Format
                      "
                      class="gc-border-bottom-dotted"
                      @value-changed="onGridValueChanged($event, data)"
                      :disabled="
                        dataGrid.model.Review == 'R' ||
                        baseView.mode == 'review'
                          ? true
                          : false
                      "
                      :min="0"
                      :max="
                        data.data.PricingMethod == 'Special Price'
                          ? 999999999.99
                          : 100.0
                      "
                      :step="0"
                      @focus-in="
                        (e) => {
                          e.event.target.select();
                        }
                      "
                    />
                  </div>
                </template>
                <template #rrp-cell-template="{ data }">
                  <div>
                    <DxNumberBox
                      :value="data.value"
                      :format="getDecimalFormatByCode(12).Format"
                      class="gc-border-bottom-dotted"
                      @value-changed="onGridValueChanged($event, data)"
                      :disabled="
                        dataGrid.model.Review != 'P' ||
                        baseView.mode == 'review' ||
                        data.data.PricingMethod != 'Special Price'
                          ? true
                          : false
                      "
                      :min="0"
                      :max="999999999.99"
                      :step="0"
                      @focus-in="
                        (e) => {
                          e.event.target.select();
                        }
                      "
                    />
                  </div>
                </template>
              </dx-data-grid>
            </div>
          </template>

          <template #rightContent>
            <DxToolbar class="split-view-toolbar">
              <DxItem
                :options="filterToolbar.clear"
                location="after"
                locate-in-menu="auto"
                widget="dxButton"
                :visible="true"
              />

              <DxItem
                :options="filterToolbar.close"
                location="after"
                widget="dxButton"
              />
            </DxToolbar>

            <div class="view-card responsive-paddings gc-advanced-filter">
              <DxScrollView
                id="filter-scrollview"
                :show-scrollbar="'always'"
                :scroll-by-content="true"
                :scroll-by-thumb="true"
                :height="advanceFilter.filterFormHeight"
              >
                <form>
                  <DxForm
                    :form-data.sync="advanceFilter.model"
                    :show-colon-after-label="false"
                    :show-required-mark="false"
                    :show-validation-summary="false"
                    :col-count-by-screen="formsConfig.splitViewColCountByScreen"
                    label-location="top"
                    :items="filterItems"
                    ref="so-filter-form"
                  >
                    <template #ProductCategory1Template="{ data }">
                      <div class="custom-auto-complete">
                        <span class="auto-complete-primary">{{
                          data.Description
                        }}</span>
                        <span class="auto-complete-secondary">{{
                          data.Code
                        }}</span>
                      </div>
                    </template>
                    <template #ProductCategory2Template="{ data }">
                      <div class="custom-auto-complete">
                        <span class="auto-complete-primary">{{
                          data.Description
                        }}</span>
                        <span class="auto-complete-secondary">{{
                          data.Code
                        }}</span>
                      </div>
                    </template>
                    <template #ProductCategory3Template="{ data }">
                      <div class="custom-auto-complete">
                        <span class="auto-complete-primary">{{
                          data.Description
                        }}</span>
                        <span class="auto-complete-secondary">{{
                          data.Code
                        }}</span>
                      </div>
                    </template>
                  </DxForm>
                </form>
              </DxScrollView>
            </div>
          </template>
        </gc-filter-split-view>
      </div>
    </div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import { mapGetters } from "vuex";
import { SalesOrderTypeService } from "../../_services/api/sales/sales-order-type.service";
import { ProductCategory1Service } from "../../_services/api/settings/products/product-category-1.service";
import appConfig from "../../app-config";
import validationEngine from "devextreme/ui/validation_engine";

import CheckBox from "devextreme/ui/check_box";
import { PriceGroupService } from "../../_services/api/sales/price-group.service";
import { CommonStorage } from "../../_services/storage";

var customerSessionDataSource = PriceGroupService.dataSourceConfig(
  "api/PriceGroupCustomerSessionList",
  {
    select: [
      "Value",
      "Type",
      "Description",
      "PriceGroupCode",
      "RecordId",
      "Include",
      "FriendlyType",
    ],
    key: "RecordId",
    filter: [["Type", "=", "CG"]],
    fieldTypes: {
      SessionId: "Guid",
      Include: "Boolean",
    },
  }
);

var BulkChange = {
  View: "PC1",
  Method: {},
  Value: {},
  IsDefault: false,
};

var productSessionsDataSource = PriceGroupService.dataSourceConfig(
  "api/PriceGroupProductSessionList",
  {
    select: [
      "Value",
      "Type",
      "Description",
      "PricingMethod",
      "SalesUM",
      "PricingMethodValue",
      "RecordId",
      "Include",
      "FriendlyType",
      "PriceGroupCode",
      "RRP",
    ],
    key: "RecordId",
    filter: [["Type", "=", "PC1"]],
    fieldTypes: {
      SessionId: "Guid",
      Include: "Boolean",
    },
    postProcess: (data) => {
      data.forEach((element) => {
        if (element.PricingMethod == null) {
          // element.PricingMethod = "Disc %";
          BulkChange.IsDefault = true;
        }

        // if(BulkChange.Method[BulkChange.View] && element.PricingMethod == null) element.PricingMethod = BulkChange.Method[BulkChange.View];
        // else if  (element.PricingMethod == null && BulkChange.View != 'R') {
        //   element.PricingMethod = "Disc %";
        // }

        // if(BulkChange.Value[BulkChange.View] && (element.PricingMethodValue == null || element.PricingMethodValue == 0)) element.PricingMethodValue = BulkChange.Value[BulkChange.View];
        // else

        if (element.PricingMethodValue == null) {
          element.PricingMethodValue = 0;
        }
        if (element.RRP == null) {
          element.RRP = 0;
        }
      });

      return data;
    },
  }
);
let screenModeChanged = false;

export default {
  props: {},
  components: {},
  mixins: [BaseViewMixin],
  updated() {
    if (this.formDataLoaded) {
      validationEngine.validateGroup(this.formsConfig.validationGroup);
      validationEngine.validateGroup("toolbarForm");
    }
  },
  data() {
    return {
      formHeight: 0,
      toolbarHeight: 0,
      customerGridExpanded: false,
      productGridExpanded: false,
      isEditVisible: true,
      SessionCreated: false,
      gridKey: 1,
      model: {
        Code: 0,
        Name: "",
        Inactive: true,
        ShortDescription: "",
        PriceGroupType: "I",
        SalesOrderTypeCode: "",
        DateControlled: true,
        SellStartDate: new Date(),
        SellEndDate: new Date(),
        IsPromotion: false,
        SessionId: undefined,
        PriceGroupCode: 0,
        Description: "",
        dataGrid: {},
        AdvertisingEndDate: null,
        AdvertisingStartDate: null,
        DateChanged: "",
        DateCreated: "",
        ChangedBy: "",
        CreatedBy: "",
        Method: undefined,
        Value: undefined,
      },
      dataGrid: {
        customer: {
          columns: [],
          dataSource: customerSessionDataSource,
        },
        product: {
          columns: [],
          dataSource: productSessionsDataSource,
        },
        remoteOperations: true,
        model: {
          Review: "CG",
          selectAll: false,
        },
        gridHeight: this.gridHeight,
      },

      toolbar: {
        edit: {
          icon: "edit",
          onClick: () => {
            screenModeChanged = true;
            CommonStorage.clear("price_group_customer_view");
            CommonStorage.clear("price_group_product_view");
            this.removeSessionID();

            BulkChange = {
              View: "PC1",
              Method: {},
              Value: {},
              IsDefault: false,
            };
            this.$router
              .push({
                path: `/price-group/edit/${this.model.Code}/${
                  this.selectedIndex == 0 ? "customer" : "product"
                }`,
              })
              .then(() => {
                this.initialize();
              });
          },
        },
        save: {
          icon: "floppy",
          validationGroup: "formsData",
          onClick: async () => {
            this.$logger.trackEventButtonClickSave();
            let mainForm = await validationEngine.validateGroup("formsData");
            let toolbarForm = await validationEngine.validateGroup(
              "toolbarForm"
            );
            if (mainForm.isValid && toolbarForm.isValid) {
              this.savePriceGroup();
            } else {
              this.addErrorMessagesFromValidationResult(mainForm);
              this.displayValidationSummary();
            }
          },
        },
        filter: {
          icon: "filter",
          onClick: () => {
            this.showRightContainer = !this.showRightContainer;
          },
        },
        audit: {
          icon: "clock",
          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
      },
      selectedItems: {
        allItems: [],
      },
      isViewModeChange: false,
      searchText: "",
      showLeftContainer: true,
      showRightContainer: false,
      filterToolbar: {
        close: {
          icon: "showpanel",
          onClick: () => {
            this.showRightContainer = !this.showRightContainer;
            document
              .querySelector(".product-grid-filter .dx-item-content .dx-button")
              .classList.remove("dx-state-invisible");
          },
        },
        clear: {
          text: "Clear",
          onClick: () => {
            this.clearAdvanceFilters();
          },
        },
      },

      advanceFilter: {
        model: {
          ProdCat1: [],
          ProdCat2: [],
          ProdCat3: [],
          ProdCat1SelectedRows: [],
          ProdCat2SelectedRows: [],
          ProdCat3SelectedRows: [],
          CreatedFilter: [],
        },
        filterFormHeight: "auto",
      },
      formDataLoaded: false,
    };
  },
  async created() {
    this.$logger.debug("created");
    if (this.baseView.mode == "review") {
      this.dataGrid.model.Review = "R";
      this.dataGrid.model.selectAll = true;
      screenModeChanged = true;
    }
    this.initialize();
    // eslint-disable-next-line no-console
    console.log(this.dateFieldsVisible, "dateFieldsVisible");
  },
  computed: {
    noDataMessage() {
      let noDataMessageObject = {
        addNew: {},
      };

      if (this.selectedIndex == 0) {
        if (this.dataGrid.model.Review == "R") {
          noDataMessageObject.addNew = {
            class: "add-new",
            title: "No Customer Lines",
            message:
              "There are no customers added to the price group yet.  Try changing the view and find the customers, groups or types that you want to add to the price group.",
          };
        } else {
          noDataMessageObject = undefined;
        }
      } else if (this.selectedIndex == 1) {
        if (this.dataGrid.model.Review == "R") {
          noDataMessageObject.addNew = {
            class: "add-new",
            title: "No Product Lines",
            message:
              "There are no products added to the price group yet.  Try changing the view and find the products or their categories that you want to add to the price group.",
          };
        } else if (this.dataGrid.model.Review == "P") {
          noDataMessageObject.addNew = {
            class: "add-new",
            title: "No Product Lines",
            message:
              " Products must be marked Active and Available for Sale to appear here.  Head over to the Product screen to adjust these settings.",
          };
        } else {
          noDataMessageObject = undefined;
        }
      } else {
        noDataMessageObject = undefined;
      }

      return noDataMessageObject;
    },
    dateFieldsVisible() {
      return this.model.DateControlled;
    },
    currentExpandFunction() {
      if (this.selectedIndex == 0) return this.expandCustomerGrid;
      else return this.expandProductGrid;
    },
    ...mapGetters({ applicationMode: "profile/applicationMode" }),
    tabs() {
      return [
        {
          text: "Customer",
          path: `/price-group/${this.baseView.mode}/${this.baseView.id}/customer`,
          applicationFeatureCode: "PriceGroup",
          ignoreRouteChange: true,
        },
        {
          text: "Product",
          path: `/price-group/${this.baseView.mode}/${this.baseView.id}/product`,
          applicationFeatureCode: "PriceGroup",
          ignoreRouteChange: true,
        },
      ];
    },
    toolbarActiveItems() {
      return this.parseFormColumns([
        {
          dataField: "Inactive",
          gcType: "Boolean",
          gcLabel: "Active",
        },
      ]);
    },
    formItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              items: this.parseFormColumns([
                {
                  dataField: "ShortDescription",
                  gcLabel: "Description",
                  gcType: "String",
                  editorType: "dxTextBox",
                  editorOptions: {
                    placeholder: "Short Description Here",
                    maxLength: 100,
                  },
                  required: true,
                },
                {
                  dataField: "PriceGroupType",
                  gcLabel: "Type",
                  gcType: "String",
                  editorType: "dxSelectBox",
                  required: true,
                  editorOptions: {
                    items: [
                      {
                        value: "I",
                        text: "Off Invoice",
                      },
                      {
                        value: "A",
                        text: "Additional Discount",
                      },
                      {
                        value: "S",
                        text: "Sales Discount",
                      },
                    ],
                    displayExpr: "text",
                    valueExpr: "value",
                    searchExpr: ["text", "value"],
                    searchMode: "contains",
                    showClearButton: true,
                  },
                },
                {
                  dataField: "SalesOrderTypeCode",
                  gcLabel: "SO Type",
                  gcType: "String",
                  editorType: "dxSelectBox",
                  editorOptions: {
                    dataSource: SalesOrderTypeService.dataSourceConfig(
                      "api/SalesOrderType",
                      {
                        select: ["Code", "Description"],
                        filter: ["Inactive", "=", "N"],
                        sort: [{ selector: "Description", asc: true }],
                      }
                    ),
                    valueExpr: "Code",
                    displayExpr: "Description",
                    searchExpr: ["Code", "Description"],
                    searchMode: "contains",
                    showClearButton: true,
                    itemTemplate: "soTemplate",
                    searchEnabled: true,
                  },
                },
                {
                  // dataField: "Method",
                  gcLabel: "Method",
                  gcType: "String",
                  editorType: "dxSelectBox",
                  visible:
                    this.selectedIndex == 1 &&
                    this.dataGrid.model.Review != "R",
                  ref: "methodChange",
                  editorOptions: {
                    items: [
                      { menuText: "Disc %" },
                      {
                        menuText: "Special Price",
                        visible:
                          this.dataGrid.model.Review == "P" ? true : false,
                      },
                    ],
                    keyExpr: "menuText",
                    displayExpr: "menuText",
                    showClearButton: false,
                    valueExpr: "menuText",
                    disabled:
                      this.dataGrid.model.Review == "R" ||
                      this.baseView.mode == "review"
                        ? true
                        : false,
                    onValueChanged: this.onBulkMethodChange,
                    value: this.model.Method
                      ? this.model.Method
                      : this.baseView.mode == "create"
                      ? "Disc %"
                      : undefined,
                  },
                },
              ]),
            },
            {
              itemType: "group",
              items: this.parseFormColumns([
                {
                  dataField: "DateControlled",
                  gcLabel: "Date Controlled",
                  gcType: "Boolean",
                },
                {
                  dataField: "SellStartDate",
                  gcLabel: "Sell Start Date",
                  visible: this.dateFieldsVisible,
                  gcType: "Date",
                  editorOptions: {
                    max: this.model.SellEndDate,
                    min: new Date(),
                    showClearButton: true,
                    acceptCustomValue: false,
                  },
                  required: this.model.DateControlled,
                },
                {
                  dataField: "SellEndDate",
                  gcLabel: "Sell End Date",
                  visible: this.dateFieldsVisible,
                  gcType: "Date",
                  editorOptions: {
                    min: this.model.SellStartDate,
                    showClearButton: true,
                    acceptCustomValue: false,
                  },
                  required: this.model.DateControlled,
                },
                {
                  // dataField: "Value",
                  gcLabel: "Value",
                  gcType: "String",
                  editorType: "dxNumberBox",
                  visible:
                    this.selectedIndex == 1 &&
                    this.model.Method != "Special Price" &&
                    this.dataGrid.model.Review != "R",
                  editorOptions: {
                    format:
                      this.model.Method == "Special Price"
                        ? this.getDecimalFormatByCode(12).Format
                        : this.getDecimalFormatByCode(6).Format,
                    class: "gc-border-bottom-dotted",
                    disabled:
                      this.dataGrid.model.Review == "R" ||
                      this.baseView.mode == "review"
                        ? true
                        : false,
                    min: 0,
                    max:
                      this.model.Method == "Special Price"
                        ? 999999999.99
                        : 100.0,
                    onValueChanged: this.onBulkValueChange,
                    value: this.model.Value
                      ? this.model.Value
                      : this.baseView.mode == "create"
                      ? 0
                      : undefined,
                    step: 0,
                  },
                },

                // {
                //   dataField: "IsPromotion",
                //   editorType: "dxSwitch",
                //   label: { text: "Is Promotion" },
                // },
              ]),
            },
          ],
        },
      ];
    },
    customerGridColumns() {
      let col = [
        {
          gcLabel: "",
          dataField: "Include",
          gcType: "String",
          headerCellTemplate: "include-header-template",
          cellTemplate: "include-cell-template",
          cssClass: "gc-editor-cell",
          width: 100,
          allowFiltering: false,
          allowSorting: false,
          allowFixing: true,
          fixedPosition: "left",
          fixed: true,
          allowReordering: false,
        },

        {
          gcLabel: "Type",
          dataField: "FriendlyType",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          allowEditing: false,
          allowFiltering: false,
          visible: this.dataGrid.model.Review == "R" ? true : false,
        },
        {
          gcLabel: "Code",
          dataField: "Value",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(120),
        },

        {
          gcLabel: "Description",
          dataField: "Description",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(220),
        },
      ];

      return this.parseGridColumns("transaction", col);
    },
    productGridColumns() {
      let col = [
        {
          gcLabel: "",
          dataField: "Include",
          gcType: "String",
          headerCellTemplate: "include-header-template",
          cellTemplate: "include-cell-template",
          cssClass: "gc-editor-cell",
          width: 100,
          allowFiltering: false,
          allowSorting: false,
          allowFixing: true,
          fixedPosition: "left",
          fixed: true,
          allowReordering: false,
        },
        {
          gcLabel: "Type",
          dataField: "FriendlyType",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          allowFiltering: false,
          visible: this.dataGrid.model.Review == "R" ? true : false,
        },

        {
          gcLabel: "Code",
          dataField: "Value",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(120),
        },
        {
          gcLabel: "Description",
          dataField: "Description",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(220),
        },
        {
          gcLabel: "UM",
          dataField: "SalesUM",
          gcType: "String",
          width: 100,
          visible:
            this.dataGrid.model.Review == "P" ||
            this.dataGrid.model.Review == "R"
              ? true
              : false,
        },
        {
          gcLabel: "Method",
          dataField: "PricingMethod",
          allowEditing: true,
          gcType: "String",
          cellTemplate: "method-cell-template",
          allowFiltering: false,
          minWidth: this.gridColumnMinWidth(180),
        },

        {
          gcLabel: "Value",
          dataField: "PricingMethodValue",
          cellTemplate: "value-cell-template",
          gcType: "DynamicDecimal",
        },
        {
          gcLabel: "RRP",
          dataField: "RRP",
          cellTemplate: "rrp-cell-template",
          gcType: "DynamicDecimal",
          visible:
            this.dataGrid.model.Review == "R" ||
            this.dataGrid.model.Review == "P"
              ? true
              : false,
        },
      ];
      return this.parseGridColumns("transaction", col);
    },
    getGridInstance() {
      var grid = undefined;
      if (this.selectedIndex == 0) {
        grid = this.$refs["customer-grid"].instance;
      } else {
        grid = this.$refs["product-grid"].instance;
      }
      return grid;
    },
    filterItems() {
      var formFields = [
        {
          itemType: "group",
          caption: "",
          items: this.parseFormColumns([
            {
              dataField: "ProdCat1",
              gcLabel: "Product Category 1",
              gcType: "String",
              editorType: "dxTagBox",
              editorOptions: {
                onValueChanged: this.applyCustomFilter.bind(this),
                dataSource: ProductCategory1Service.dataSourceConfig(
                  "api/ProductCategory1",
                  {
                    select: ["Code", "Description"],
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                itemTemplate: "ProductCategory1Template",
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                showClearButton: true,
              },
            },
            {
              dataField: "ProdCat2",
              gcLabel: "Product Category 2",
              gcType: "String",
              editorType: "dxTagBox",
              editorOptions: {
                onValueChanged: this.applyCustomFilter.bind(this),
                dataSource: ProductCategory1Service.dataSourceConfig(
                  "api/ProductCategory2",
                  {
                    select: ["Code", "Description"],
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                itemTemplate: "ProductCategory2Template",
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                showClearButton: true,
              },
            },
            {
              dataField: "ProdCat3",
              gcLabel: "Product Category 3",
              gcType: "String",
              editorType: "dxTagBox",
              editorOptions: {
                onValueChanged: this.applyCustomFilter.bind(this),
                dataSource: ProductCategory1Service.dataSourceConfig(
                  "api/ProductCategory3",
                  {
                    select: ["Code", "Description"],
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                itemTemplate: "ProductCategory3Template",
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                showClearButton: true,
              },
            },
          ]),
        },
      ];

      return formFields;
    },
  },
  methods: {
    async bulkMethodUpdate() {
      BulkChange.IsDefault = false;
      this.showLoading(true);
      let payload = {
        PricingMethod: BulkChange.Method[BulkChange.View]
          ? BulkChange.Method[BulkChange.View]
          : "Disc %",
        PricingMethodValue: BulkChange.Value[BulkChange.View]
          ? BulkChange.Value[BulkChange.View]
          : 0,
        SessionId: this.model.SessionId,
        Type: BulkChange.View,
      };
      await PriceGroupService.saveBulkMethod(payload)
        .then((res) => {
          if (res) this.showLoading(false);
          productSessionsDataSource.filter([
            ["Type", "=", BulkChange.View],
            "and",
            ["SessionId", "=", this.model.SessionId],
          ]);
          productSessionsDataSource.load();
        })
        .catch((err) => {
          if (err) this.showLoading(false);
        });
    },
    async onBulkValueChange(e) {
      BulkChange.View = this.dataGrid.model.Review;

      e.component.option("onValueChanged", null);

      var items = [
        {
          value: "PC1",
          text: "Category 1",
        },
        {
          value: "PC2",
          text: "Category 2",
        },
        {
          value: "PC3",
          text: "Category 3",
        },
        {
          value: "P",
          text: "Product",
        },
        {
          value: "R",
          text: "Review",
        },
      ];
      var view = items.filter((x) => x.value == this.dataGrid.model.Review);

      let confirmValueChange = await this.$confirm(
        `Changing the pricing value will update the price for the ${view[0].text} (current view) only, are you sure you want to continue?`,
        "Confirm Value Change"
      );

      if (confirmValueChange) {
        this.model.Value = e.value;
        BulkChange.Value[BulkChange.View] = e.value;
        e.component.option("value", e.value);

        // this.getGridInstance.refresh();
        this.bulkMethodUpdate();
      } else {
        this.model.Value = e.previousValue ? e.previousValue : "";
        e.component.option("value", e.previousValue);
        BulkChange.Value[BulkChange.View] = e.previousValue;
      }

      setTimeout(() => {
        e.component.option("onValueChanged", this.onBulkValueChange.bind(this));
      }, 500);
    },
    async onBulkMethodChange(e) {
      BulkChange.View = this.dataGrid.model.Review;

      e.component.option("onValueChanged", null);

      var items = [
        {
          value: "PC1",
          text: "Category 1",
        },
        {
          value: "PC2",
          text: "Category 2",
        },
        {
          value: "PC3",
          text: "Category 3",
        },
        {
          value: "P",
          text: "Product",
        },
        {
          value: "R",
          text: "Review",
        },
      ];
      var view = items.filter((x) => x.value == this.dataGrid.model.Review);

      let confirmBulkChange = await this.$confirm(
        `Changing the pricing method will update the method for the ${view[0].text} (current view) only, are you sure you want to continue?`,
        "Confirm Method Change"
      );

      if (confirmBulkChange) {
        this.model.Method = e.value;
        BulkChange.Method[BulkChange.View] = e.value;
        BulkChange.Value[BulkChange.View] = 0;
        this.model.Value = 0;

        // this.getGridInstance.refresh();
        this.bulkMethodUpdate();
      } else {
        this.model.Method = e.previousValue ? e.previousValue : "";
        e.component.option("value", e.previousValue);
        BulkChange.Method[BulkChange.View] = e.previousValue;
      }

      setTimeout(() => {
        e.component.option(
          "onValueChanged",
          this.onBulkMethodChange.bind(this)
        );
      }, 500);
    },
    expandProductGrid() {
      this.productGridExpanded = !this.productGridExpanded;
      this.$refs["product-grid"].instance.repaint(true);
    },
    expandCustomerGrid() {
      this.customerGridExpanded = !this.customerGridExpanded;
      this.$refs["customer-grid"].instance.repaint(true);
    },
    async selectAllItem(e, data, refs) {
      if (data.data.PricingMethod == null && this.selectedIndex == 1) {
        var checkBox = this.$refs[refs].instance;
        checkBox.reset();
        this.displayValidationSummary([]);
        this.addErrorMessage(`Product must contain a Pricing Method`);
        this.displayValidationSummary();

        return;
      }
      if (e.value && this.dataGrid.model.selectAll == false) {
        var element = this.$refs["cus-select-all"].instance.element();
        var getInstance = CheckBox.getInstance(element);
        getInstance.option("value", undefined);
      }
      if (this.selectedIndex == 0) {
        await this.saveSelectedItem("api/PriceGroupCustomerSession", {
          PriceGroupCode: data.data.PriceGroupCode,
          SessionId: this.model.SessionId,
          Include: e.value,
          Type: data.data.Type,
          Value: data.data.Value,
          RecordId: data.data.RecordId._value,
        });
      } else {
        if (data.data.PricingMethod != null) {
          await this.saveSelectedItem("api/PriceGroupProductSession", {
            PriceGroupCode: data.data.PriceGroupCode,
            SessionId: this.model.SessionId,
            Include: e.value,
            Type: data.data.Type,
            Value: data.data.Value,
            RecordId: data.data.RecordId,
            PricingMethod: data.data.PricingMethod,
            PricingMethodValue: data.data.PricingMethodValue,
          });
        }
      }
    },
    selectAllItems(e) {
      if (
        e.value == undefined ||
        e.event == undefined ||
        this.dataGrid.model.Review == "R"
      ) {
        return;
      }
      var payload = {
        Include: e.value,
        Type:
          this.dataGrid.model.Review == "R" ? "" : this.dataGrid.model.Review,
        PriceGroupCode: this.model.PriceGroupCode,
        SessionId: this.model.SessionId,
        SearchFilter: this.searchText,
      };
      if (this.model.PriceGroupCode == 0) {
        delete payload.PriceGroupCode;
      }

      if (this.selectedIndex == 0) {
        this.sessionBulkInclude(
          "api/Save_PriceGroupCustomerSessionBulkInclude",
          payload
        );
      } else {
        var prodCat1Codes = [];
        this.advanceFilter.model.ProdCat1.forEach((element) => {
          prodCat1Codes.push({
            Code: element,
          });
        });
        payload.PriceGroupProductSessionBulkIncludeProductCategory1s =
          prodCat1Codes;

        var prodCat2Codes = [];
        this.advanceFilter.model.ProdCat2.forEach((element) => {
          prodCat2Codes.push({
            Code: element,
          });
        });
        payload.PriceGroupProductSessionBulkIncludeProductCategory2s =
          prodCat2Codes;

        var prodCat3Codes = [];
        this.advanceFilter.model.ProdCat3.forEach((element) => {
          prodCat3Codes.push({
            Code: element,
          });
        });
        payload.PriceGroupProductSessionBulkIncludeProductCategory3s =
          prodCat3Codes;

        this.sessionBulkInclude(
          "api/Save_PriceGroupProductSessionBulkInclude",
          payload
        );
      }
    },
    async applyCustomFilter() {
      this.dataGrid.model.selectAll == false;
      this.advanceFilter.model.CreatedFilter = [];
      const createFilter = [];
      if (this.advanceFilter.model.ProdCat1.length != 0) {
        let afilter = [];
        for (
          let index = 0;
          index < this.advanceFilter.model.ProdCat1.length;
          index++
        ) {
          let filter = [
            "ProductCategory1Code",
            "=",
            this.advanceFilter.model.ProdCat1[index],
          ];
          afilter.push(filter);
          if (index != this.advanceFilter.model.ProdCat1.length - 1) {
            afilter.push("or");
          }
        }
        createFilter.push(afilter);
      }

      if (this.advanceFilter.model.ProdCat2.length != 0) {
        let afilter = [];
        for (
          let index = 0;
          index < this.advanceFilter.model.ProdCat2.length;
          index++
        ) {
          let filter = [
            "ProductCategory2Code",
            "=",
            this.advanceFilter.model.ProdCat2[index],
          ];
          afilter.push(filter);
          if (index != this.advanceFilter.model.ProdCat2.length - 1) {
            afilter.push("or");
          }
        }

        if (createFilter.length > 0) {
          createFilter.push("and");
          createFilter.push(afilter);
        } else {
          createFilter.push(afilter);
        }
      }

      if (this.advanceFilter.model.ProdCat3.length != 0) {
        let afilter = [];
        for (
          let index = 0;
          index < this.advanceFilter.model.ProdCat3.length;
          index++
        ) {
          let filter = [
            "ProductCategory3Code",
            "=",
            this.advanceFilter.model.ProdCat3[index],
          ];
          afilter.push(filter);
          if (index != this.advanceFilter.model.ProdCat3.length - 1) {
            afilter.push("or");
          }
        }

        if (createFilter.length > 0) {
          createFilter.push("and");
          createFilter.push(afilter);
        } else {
          createFilter.push(afilter);
        }
      }

      if (createFilter.length != 0) {
        this.advanceFilter.model.CreatedFilter = createFilter;
        createFilter.push("and");
      } else {
        this.advanceFilter.model.CreatedFilter = [];
      }
      createFilter.push([
        ["Type", "=", this.dataGrid.model.Review],
        "and",
        ["SessionId", "=", this.model.SessionId],
      ]);

      await productSessionsDataSource.filter(createFilter);
      productSessionsDataSource.load().then((result) => {
        var included = result.filter((item) => item.Include == true);

        if (createFilter.length != 0) {
          if (included.length == 0) {
            this.dataGrid.model.selectAll = false;
          } else if (included.length == result.length) {
            this.dataGrid.model.selectAll = true;
          } else {
            var element = this.$refs["cus-select-all"].instance.element();
            var getInstance = CheckBox.getInstance(element);
            getInstance.option("value", undefined);
          }
        }
      });
    },

    clearAdvanceFilters() {
      this.advanceFilter.model.ProdCat1 = [];
      this.advanceFilter.model.ProdCat2 = [];
      this.advanceFilter.model.ProdCat3 = [];
      this.advanceFilter.model.CreatedFilter = [];
    },
    async initialize() {
      this.$logger.debug("init");
      this.SessionCreated = false;
      this.formDataLoaded = false;
      this.model.SessionId = undefined;
      this.showLoading(true);
      let that = this;
      this.searchText = "";
      this.clearAdvanceFilters();
      this.showRightContainer = false;

      if (localStorage.getItem(`SessionId_${appConfig.VUE_APP_COOKIE_NAME}`)) {
        await PriceGroupService.postPriceGroupSessionCancel().then((result) => {
          if (result) {
            localStorage.removeItem(
              `SessionId_${appConfig.VUE_APP_COOKIE_NAME}`
            );
          }
        });
      }
      if (this.baseView.mode == "create") {
        await this.createSessionID(0);
        BulkChange.View = "PC1";
        BulkChange.Method[BulkChange.View] = "Disc %";
        BulkChange.Value[BulkChange.View] = 0;
        this.showLoading(false);
        this.formDataLoaded = true;
      } else {
        await this.createSessionID(this.baseView.id);
        await this.getRecord()
          .then((result) => {
            this.$logger.debug("get price group - result ", result);
            this.model.Name = `Price Group # ${result.data.value[0].Code}`;
            this.model.Code = result.data.value[0].Code;
            this.model.Description = result.data.value[0].Description
              ? result.data.value[0].Description
              : result.data.value[0].ShortDescription;

            if (result.data.value[0].Inactive == "N") {
              this.model.Inactive = true;
            } else {
              this.model.Inactive = false;
            }
            this.model.ShortDescription = result.data.value[0].ShortDescription;
            this.model.PriceGroupType = result.data.value[0].PriceGroupType;
            this.model.SalesOrderTypeCode =
              result.data.value[0].SalesOrderTypeCode;
            this.model.DateControlled = result.data.value[0].DateControlled;
            this.model.SellStartDate = new Date(
              result.data.value[0].SellStartDate
            );
            this.model.SellEndDate = new Date(result.data.value[0].SellEndDate);

            this.model.AdvertisingEndDate =
              result.data.value[0].AdvertisingEndDate;
            this.model.AdvertisingStartDate =
              result.data.value[0].AdvertisingStartDate;

            if (result.data.value[0].IsPromotion == "N") {
              this.model.IsPromotion = false;
            } else {
              this.model.IsPromotion = true;
            }
            this.model.DateChanged = result.data.value[0].DateChanged;
            this.model.DateCreated = result.data.value[0].DateCreated;
            this.model.ChangedBy = result.data.value[0].ChangedBy;
            this.model.CreatedBy = result.data.value[0].CreatedBy;

            that.refreshView();
            this.showLoading(false);
            this.formDataLoaded = true;
          })
          .catch((err) => {
            this.$logger.debug("get price group - err ", err);
            this.showLoading(false);
            this.formDataLoaded = true;
          });

        if (this.baseView.tab === "product") {
          this.productListFilter(this.dataGrid.model.Review);
        } else {
          this.customerListFilter(this.dataGrid.model.Review);
        }
      }
    },
    async onGridValueChanged(valueChangedEventArg, cellInfo) {
      cellInfo.value = valueChangedEventArg.value;
      // cellInfo.data.PricingMethodValue = valueChangedEventArg.value;
      cellInfo.data[cellInfo.column.dataField] = valueChangedEventArg.value;
      // if (cellInfo.data.Include == true) {
      await this.saveSelectedItem(
        "api/PriceGroupProductSession",
        {
          PriceGroupCode: cellInfo.data.PriceGroupCode,
          SessionId: this.model.SessionId,
          // Include: true,
          Type: cellInfo.data.Type,
          Value: cellInfo.data.Value,
          RecordId: cellInfo.data.RecordId,
          PricingMethod: cellInfo.data.PricingMethod,
          PricingMethodValue: cellInfo.data.PricingMethodValue,
          RRP: cellInfo.data.RRP,
        },
        true
      );
      // }
    },
    async onMethodValueChange(valueChangedEventArg, cellInfo) {
      cellInfo.value = valueChangedEventArg.value;
      cellInfo.data.PricingMethod = valueChangedEventArg.value;
      this.$logger.debug("aa ", cellInfo);
      // if (cellInfo.data.Include == true) {

      var fromCell = true;
      if (cellInfo.data.RRP > 0) {
        cellInfo.data.RRP = 0;
        fromCell = false;
      }

      await this.saveSelectedItem(
        "api/PriceGroupProductSession",
        {
          PriceGroupCode: cellInfo.data.PriceGroupCode,
          SessionId: this.model.SessionId,
          // Include: true,
          Type: cellInfo.data.Type,
          Value: cellInfo.data.Value,
          RecordId: cellInfo.data.RecordId,
          PricingMethod: cellInfo.data.PricingMethod,
          PricingMethodValue: cellInfo.data.PricingMethodValue,
          RRP: cellInfo.data.RRP,
        },
        fromCell
      );
      // }
    },
    async savePriceGroup() {
      this.showLoading(true);
      this.$logger.debug("+++++ ", this.model);
      await PriceGroupService.savePriceGroup(
        {
          Inactive: this.model.Inactive ? "N" : "Y",
          ShortDescription: this.model.ShortDescription,
          PriceGroupType: this.model.PriceGroupType,
          SalesOrderTypeCode: this.model.SalesOrderTypeCode,
          DateControlled: this.model.DateControlled ? "Y" : "N",
          SellStartDate: this.model.SellStartDate.toSaveDate(),
          SellEndDate: this.model.SellEndDate.toSaveDate(),
          IsPromotion: this.model.IsPromotion ? "Y" : "N",
          SessionId: this.model.SessionId,
          Description: this.model.ShortDescription,
          AdvertisingEndDate: this.model.AdvertisingEndDate,
          AdvertisingStartDate: this.model.AdvertisingStartDate,
          Code: this.model.Code,
        },
        this.model.Code == 0 ? false : this.model.Code
      )
        .then((result) => {
          this.$logger.debug("savePriceGroup result", result);

          this.showLoading(false);
          if (this.baseView.mode == "create") {
            this.model.Code = result.data.Code;
          }
          this.$notify(
            `Price group ${this.model.Name} saved successfully`,
            "success"
          );
          this.setIgnoreRouteChangeConfirmation();
          CommonStorage.clear("price_group_customer_view");
          CommonStorage.clear("price_group_product_view");
          this.removeSessionID();

          BulkChange = {
            View: "PC1",
            Method: {},
            Value: {},
            IsDefault: false,
          };
          this.$router
            .push({
              path: `/price-group/review/${this.model.Code}`,
            })
            .then(() => {
              this.initialize();
            });
        })
        .catch((err) => {
          this.showLoading(false);
          this.$logger.debug("savePriceGroup err", err);

          this.displayServerError(err, "Price group save failed");
        });
    },
    async createSessionID(id) {
      await PriceGroupService.postPriceGroupSessionCreate(id)
        .then((result) => {
          this.$logger.debug("resutls ", result);

          this.model.SessionId = result.data.SessionId;
          localStorage.setItem(
            `SessionId_${appConfig.VUE_APP_COOKIE_NAME}`,
            result.data.SessionId
          );
          this.SessionCreated = true;
          // if (this.baseView.tab === "product") {
          //   this.productListFilter(this.dataGrid.model.Review);
          // } else {
          //   this.customerListFilter(this.dataGrid.model.Review);
          // }
        })
        .catch((err) => {
          this.$logger.debug("err createSessionID", err);
          this.SessionCreated = true;
        });
    },
    onInitialized() {
      this.$logger.debug("onInitialized");
      if (this.baseView.tab === "product") {
        this.productListFilter(this.dataGrid.model.Review);
      } else {
        this.customerListFilter(this.dataGrid.model.Review);
      }
    },
    async getRecord() {
      return await PriceGroupService.getByCode(this.baseView.id);
    },
    async saveSelectedItem(url, payload, fromCell = false) {
      await PriceGroupService.saveSelectedItems(url, payload)
        .then(async (result) => {
          this.$logger.debug("saveSelectedItem result ", result);
          if (!fromCell) {
            this.getGridInstance.refresh();
          }

          if (this.advanceFilter.model.CreatedFilter.length > 0) {
            this.applyCustomFilter();
          }
        })
        .catch((err) => {
          this.$logger.debug("saveSelectedItem err ", err);
        });
    },
    async sessionBulkInclude(url, payload) {
      await PriceGroupService.sessionBulkInclude(url, payload)
        .then((result) => {
          this.$logger.debug("sessionBulkInclude result  ", result);
          this.getGridInstance.refresh();
        })
        .catch((err) => {
          this.$logger.debug("err  sessionBulkInclude", err);
        });
    },
    async getIncludedTotal(url, filter) {
      return PriceGroupService.getTotalCount(url, filter)
        .then((result) => {
          this.$logger.debug("result  getIncludedTotal", result);
          if (result.data["@odata.count"] == 1) {
            if (result.data.value[0].Include == false) {
              return false;
            } else if (result.data.value[0].Include == true) {
              return true;
            }
          } else {
            return undefined;
          }
        })
        .catch((error) => {
          this.$logger.debug("err  getIncludedTotal", error);
          return false;
        });
    },
    async onContentReadyCustomerGrid(e) {
      if (this.dataGrid.model.Review != "R") {
        this.markSelectAllCheckBox("api/PriceGroupCustomerSessionList");
      }
      this.addGridNoResults(e);
      CommonStorage.saveItems(
        "price_group_customer_view",
        this.dataGrid.model.Review
      );
    },
    async markSelectAllCheckBox(url) {
      this.$logger.debug("url  url", url);
      // this.$logger.debug("grid instance ", this.getGridInstance);
      this.getGridInstance.off("contentReady", null);

      var checkBox = this.$refs["cus-select-all"].instance;
      checkBox.off("valueChanged", null);

      var filterValue = `Type eq '${this.dataGrid.model.Review}' and SessionId eq ${this.model.SessionId}`;
      if (this.searchText != "") {
        if (this.selectedIndex == 0) {
          filterValue =
            filterValue +
            ` and ((contains(tolower(FriendlyType), '${this.searchText}')) or (contains(tolower(Value),'${this.searchText}')) or (contains(tolower(Description),'${this.searchText}')))`;
        } else {
          filterValue =
            filterValue +
            ` and ((contains(tolower(FriendlyType),'${this.searchText}')) or (contains(tolower(Value),'${this.searchText}')) or (contains(tolower(Description),'${this.searchText}')) or (SalesUM eq '${this.searchText}'))`;
        }
      }

      var includeItemTotal = await this.getIncludedTotal(
        url,
        "filter(" +
          filterValue +
          ")/groupby((Include),aggregate($count as itemCount))"
      );

      var element = this.$refs["cus-select-all"].instance.element();
      var getInstance = CheckBox.getInstance(element);
      getInstance.option("value", includeItemTotal);

      checkBox.on("valueChanged", this.selectAllItems.bind(this));

      setTimeout(() => {
        if (this.selectedIndex == 0) {
          this.getGridInstance.on(
            "contentReady",
            this.onContentReadyCustomerGrid.bind(this)
          );
        } else {
          this.getGridInstance.on(
            "contentReady",
            this.onContentReadyProductGrid.bind(this)
          );
        }
      }, 500);
    },
    async onContentReadyProductGrid(e) {
      if (
        this.dataGrid.model.Review != "R" &&
        this.advanceFilter.model.CreatedFilter.length == 0
      ) {
        this.markSelectAllCheckBox("api/PriceGroupProductSessionList");
      }
      setTimeout(() => {
        this.addGridNoResults(e);
      }, 500);

      CommonStorage.saveItems(
        "price_group_product_view",
        this.dataGrid.model.Review
      );

      if (BulkChange.IsDefault == true && this.baseView.mode == "create")
        this.bulkMethodUpdate();
    },
    async viewModeChange(e) {
      this.searchText = "";
      this.advanceFilter.model.CreatedFilter = [];
      this.isViewModeChange = true;
      this.dataGrid.model.Review = e.value;
      this.dataGrid.model.selectAll = false;
      if (this.selectedIndex == 0) {
        this.customerListFilter(e.value);
      } else {
        BulkChange.IsDefault = false;
        BulkChange.View = e.value;
        this.model.Method = BulkChange.Method[BulkChange.View];
        this.model.Value = BulkChange.Value[BulkChange.View];
        // if(this.baseView.mode == "create")
        //   this.bulkMethodUpdate();
        // this.clearAdvanceFilters();
        this.showRightContainer = false;
        document
          .querySelector(".product-grid-filter .dx-item-content .dx-button")
          .classList.add("dx-state-invisible");
        this.productListFilter(e.value);
      }
    },
    async customerListFilter(value) {
      // const grid = this.$refs["customer-grid"].instance;
      // grid.clearSelection();

      if (value == "R") {
        await customerSessionDataSource.filter([
          ["Include", "=", true],
          "and",
          ["SessionId", "=", this.model.SessionId],
        ]);
        customerSessionDataSource.load().then((result) => {
          if (result.length == 0) {
            this.dataGrid.model.selectAll = false;
          } else {
            this.dataGrid.model.selectAll = true;
          }
        });
      } else {
        await customerSessionDataSource.filter([
          ["Type", "=", value],
          "and",
          ["SessionId", "=", this.model.SessionId],
        ]);
      }
    },
    async productListFilter(value) {
      // const grid = this.$refs["product-grid"].instance;
      // grid.clearSelection();

      if (value == "P") {
        document
          .querySelector(".product-grid-filter .dx-item-content .dx-button")
          .classList.remove("dx-state-invisible");
      } else {
        if (
          document.querySelector(
            ".product-grid-filter .dx-item-content .dx-button"
          )
        )
          document
            .querySelector(".product-grid-filter .dx-item-content .dx-button")
            .classList.add("dx-state-invisible");
      }

      if (value == "R") {
        await productSessionsDataSource.filter([
          ["Include", "=", true],
          "and",
          ["SessionId", "=", this.model.SessionId],
        ]);
        productSessionsDataSource.load().then((result) => {
          if (result.length == 0) {
            this.dataGrid.model.selectAll = false;
          } else {
            this.dataGrid.model.selectAll = true;
          }
        });
      } else {
        await productSessionsDataSource.filter([
          ["Type", "=", value],
          "and",
          ["SessionId", "=", this.model.SessionId],
        ]);

        productSessionsDataSource.load().then((result) => {
          if (
            result &&
            BulkChange.IsDefault &&
            this.baseView.mode == "create"
          ) {
            this.bulkMethodUpdate();
          }
        });
      }
    },
    onToolbarPreparingPGCustomer(e) {
      var toolbarItems = e.toolbarOptions.items;

      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      let itemsToRemoveFromToolBar = ["searchPanel"];

      e.toolbarOptions.items = toolbarItems.filter(
        (item) => !itemsToRemoveFromToolBar.includes(item.name)
      );

      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxSelectBox",
          options: {
            width: 200,
            items: [
              {
                value: "CG",
                text: "Group",
              },
              {
                value: "CT",
                text: "Type",
              },
              {
                value: "C",
                text: "Customer",
              },
              {
                value: "R",
                text: "Review",
              },
            ],
            displayExpr: "text",
            valueExpr: "value",
            value: this.dataGrid.model.Review,
            readOnly: this.baseView.mode === "review",
            onValueChanged: this.viewModeChange.bind(this),
          },
        },
        searchPanel,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: this.customerGridExpanded ? "collapse" : "expand",
            onClick: this.expandCustomerGrid,
          },
        }
      );
    },
    onToolbarPreparingPGProduct(e) {
      var toolbarItems = e.toolbarOptions.items;

      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      let itemsToRemoveFromToolBar = ["searchPanel"];

      e.toolbarOptions.items = toolbarItems.filter(
        (item) => !itemsToRemoveFromToolBar.includes(item.name)
      );

      searchPanel.location = "after";

      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxSelectBox",
          options: {
            width: 200,
            items: [
              {
                value: "PC1",
                text: "Category 1",
              },
              {
                value: "PC2",
                text: "Category 2",
              },
              {
                value: "PC3",
                text: "Category 3",
              },
              {
                value: "P",
                text: "Product",
              },
              {
                value: "R",
                text: "Review",
              },
            ],
            displayExpr: "text",
            valueExpr: "value",
            value: this.dataGrid.model.Review,
            onValueChanged: this.viewModeChange.bind(this),
            readOnly: this.baseView.mode === "review",
          },
        },
        searchPanel,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          cssClass: "product-grid-filter",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            onClick: () => {
              this.showRightContainer = !this.showRightContainer;
              document
                .querySelector(
                  ".product-grid-filter .dx-item-content .dx-button"
                )
                .classList.add("dx-state-invisible");
            },
            onContentReady: () => {},
            visible: false,
          },
        },
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: this.productGridExpanded ? "collapse" : "expand",
            onClick: this.expandProductGrid,
          },
        }
      );
    },
    onContentReady() {
      if (document.getElementsByClassName("price-group-form").length != 0) {
        this.formHeight =
          document.getElementsByClassName("price-group-form")[0].clientHeight;
        this.toolbarHeight = document.getElementsByClassName(
          "price-group-toolbar"
        )[0].clientHeight;
      }
    },
    backButtonFunction() {
      this.$router.push({
        path: "/price-group",
      });
    },
    async setTabSelection() {
      if (this.baseView.tab === "product") {
        if (!screenModeChanged) {
          if (this.baseView.mode == "review") {
            this.dataGrid.model.Review = "R";
          } else {
            if (CommonStorage.getItems("price_group_product_view")) {
              this.dataGrid.model.Review = CommonStorage.getItems(
                "price_group_product_view"
              );
            } else {
              this.dataGrid.model.Review = "PC1";
            }
          }
        } else {
          screenModeChanged = false;
        }
        this.searchText = "";
        this.onContentReady();
        this.selectedIndex = 1;
        // setTimeout(() => {
        //   if (this.model.SessionId != undefined)
        //     this.productListFilter(this.dataGrid.model.Review);
        // }, 250);
      } else {
        if (!screenModeChanged) {
          if (this.baseView.mode == "review") {
            this.dataGrid.model.Review = "R";
          } else {
            if (CommonStorage.getItems("price_group_customer_view")) {
              this.dataGrid.model.Review = CommonStorage.getItems(
                "price_group_customer_view"
              );
            } else {
              this.dataGrid.model.Review = "CG";
            }
          }
        } else {
          screenModeChanged = false;
        }
        this.onContentReady();
        this.selectedIndex = 0;
        // setTimeout(() => {
        //   if (this.model.SessionId != undefined)
        //     this.customerListFilter(this.dataGrid.model.Review, 'timeout');
        // }, 250);
      }
    },
    async handleLocalRouteChange() {
      setTimeout(() => {
        this.setTabSelection();
      }, 100);
    },
    removeSessionID() {
      PriceGroupService.postPriceGroupSessionCancel().then((result) => {
        if (result) {
          localStorage.removeItem(`SessionId_${appConfig.VUE_APP_COOKIE_NAME}`);
          this.model.SessionId = null;
          this.model.SessionCreated = false;
        }
      });
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },

    "model.DateControlled": function (currValue, prevValue) {
      if (currValue && !prevValue) this.model.SellStartDate = new Date();
      this.model.SellEndDate = new Date();
    },
    // selectedIndex(val) {
    // if(val == 1 && this.baseView.mode == "create") this.bulkMethodUpdate();
    // }
  },
  beforeDestroy() {
    CommonStorage.clear("price_group_customer_view");
    CommonStorage.clear("price_group_product_view");
    this.removeSessionID();

    BulkChange = {
      View: "PC1",
      Method: {},
      Value: {},
      IsDefault: false,
    };
  },
};
</script>

<style lang="scss">
.price-group{
  .gc-header-form.expanded{
    padding-bottom: 0 !important;
  }
}
</style>